<template>
  <div class="ChartShowSet">
    <!-- 循环字段 进行字段的样式设置 addFieldSet -->
    <el-form style="background-color: white;" label-width="120px" label-suffix=":">
      <template v-for="(blockOne,blockIndex) in blockArr" >
        {{blockOne.blockCnName}}:
        <el-row type="flex" style="flex-wrap:wrap;" :key="'block_'+blockIndex" >
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="(fieldOne,fieldIndex) in blockOne.fieldArr" :key="'block_'+fieldIndex" >
            <el-form-item :label="fieldOne.cnName">
              <template v-if="fieldOne.type == 1">
                <el-select 
                  v-model="value[fieldOne.enName]" clearable
                  :multiple="false"
                >
                  <el-option v-for="(dicOne,dicIndex) in fieldOne.dicList" :key="'dic_'+dicIndex" :label="dicOne.label" :value="dicOne.value"></el-option>
                </el-select>
              </template>
              <template v-else-if="fieldOne.type == 2">
                <template v-if="fieldOne.inputArr">
                  <el-input v-for="(inputOne,inputIndex) in fieldOne.inputArr" :key="'input_'+inputIndex" type="text" v-model="value[inputOne.enName]" :placeholder="inputOne.placeholder"><template slot="prepend">{{inputOne.cnName}}</template></el-input>
                </template>
                <el-input v-else type="text" v-model="value[fieldOne.enName]" :placeholder="fieldOne.placeholder"><template slot="prepend">{{fieldOne.cnName}}</template></el-input>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
</template>

<script>
  import pageUtils from '@/js/page/pageUtil.js';
  import utils from '@/js/utils/util.js';
export default {
  name: 'ChartShowSet',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    },
    ImageList:{
      type:Array
    },
    ImageType:{

    }
  },
  data() {
    return {
      blockArr:[{
          blockCnName:"图表展现样式",
          fieldArr:[{
            cnName:"图表默认形式",
            enName:"chartType",
            type:1,
            dicList:[{label:"折线图",value:"折线图"},{label:"柱状图",value:"柱状图"},{label:"条形图",value:"条形图"},{label:"饼图",value:"饼图"},{label:"环图",value:"环图"},{label:"瀑布图",value:"瀑布图"},{label:"漏斗图",value:"漏斗图"},{label:"雷达图",value:"雷达图"},{label:"热力图",value:"热力图"},{label:"散点图",value:"散点图"}]
          },{
            cnName:"宽高",
            inputArr:[{cnName:"宽度",enName:"chartWidth",placeholder:"auto"},
              {cnName:"高度",enName:"chartHeigth",placeholder:"400px"}],
            type:2
          }]
        },{
          blockCnName:"title显示设置",
          fieldArr:[{
            cnName:"title是否显示",
            enName:"titleIfShow",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"title的位置",
            inputArr:[{cnName:"left",enName:"titleLeft",placeholder:"center"},
              {cnName:"top",enName:"titleTop",placeholder:"auto"},
              {cnName:"right",enName:"titleRight",placeholder:"center"},
              {cnName:"buttom",enName:"titleButtom",placeholder:"auto"}],
            type:2
          },{
            cnName:"title的fontSize",
            enName:"titleFontSize",
            placeholder:"14px",
            type:2,
          },{
            cnName:"title的fontColor",
            enName:"titleFontColor",
            placeholder:"#333",
            type:2,
          }]
        },{
          blockCnName:"legend样式设置",
          fieldArr:[{
            cnName:"legend是否显示",
            enName:"legendIfShow",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"legend的展现形式",
            enName:"legendOrient",
            placeholder:"vertical",
            type:2,
          },{
            cnName:"legend的位置",
            inputArr:[{cnName:"left",enName:"legendLeft",placeholder:"center"},
              {cnName:"top",enName:"legendTop",placeholder:"auto"},
              {cnName:"right",enName:"legendRight",placeholder:"center"},
              {cnName:"buttom",enName:"legendButtom",placeholder:"auto"}],
            type:2
          },{
            cnName:"legend图表宽高",
            inputArr:[{cnName:"宽度",enName:"legendItemWidth",placeholder:15},
              {cnName:"高度",enName:"legendItemHeigth",placeholder:7}],
            type:2
          },{
            cnName:"legend的fontSize",
            enName:"legendFontSize",
            placeholder:"12",
            type:2,
          },{
            cnName:"legend的fontColor",
            enName:"legendFontColor",
            placeholder:"#000",
            type:2,
          }]
        },{
          blockCnName:"series样式设置",
          fieldArr:[{
            cnName:"series的radius圆环大小",
            enName:"seriesRadius",
            placeholder:"['30%','60%']",
            type:2,
          },{
            cnName:"series的center中心位置",
            enName:"seriesCenter",
            placeholder:"['50%','50%']",
            type:2,
          },{
            cnName:"label是否显示",
            enName:"seriesLabelIfShow",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"label显示位置",
            enName:"seriesLabelPosition",
            type:1,
            dicList:[{label:"内部",value:"inside"},{label:"外部",value:"outside"}]
          },{
            cnName:"label显示内容",
            enName:"seriesLabelFormatter",
            placeholder:"{c}个",
            type:2,
          }]
        },{
          blockCnName:"点击图表数据穿透跳转功能",
          fieldArr:[{
            cnName:"图表双击事件",
            enName:"clickType",
            type:1,
            dicList:[{label:"无",value:"1"},{label:"加载详情页",value:"2"},{label:"跳转列表页",value:"3"},{label:"跳转详情页",value:"4"},{label:"跳转列表页(并选中)",value:"5"},{label:"后台选项卡打开列表",value:"6"},{label:"后台选项卡打开查看页面",value:"7"}]
          },{
            cnName:"点击跳转",
            inputArr:[{cnName:"对象ID",enName:"clickTableId",placeholder:""},
              {cnName:"PageID",enName:"clickPageId",placeholder:""},
              {cnName:"主键Key别名",enName:"clickMainAliasName",placeholder:"T_tableId_0"}],
            type:2
          }]
        }
      ]
    };
  },
  created() {
    console.log("this.value=================",this.value);
  },
  mounted() {
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-col{min-height: 41px;padding: 3px}
</style>
